import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.css';

import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import reducer from './reducers';
import { Router } from "react-router-dom";
import history from "./history";

import App from './App';
import UnderMenu from './components/UnderMenu'

const middleware = [thunk, createLogger()];
const store = createStore(reducer, applyMiddleware(...middleware));

if (document.querySelector('h1') && document.querySelector('h1').innerHTML === 'Страница не найдена') {
  const authModule = document.body.insertBefore(document.createElement('div'), document.body.children[0]);
  const lang = 'ru';
  authModule.setAttribute('id', 'auth-module');

  const btnUnderMenu = document.querySelector('.head_menu').appendChild(document.createElement("div"));
  btnUnderMenu.setAttribute("id", "auth-under-menu");
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router history={history}>
          <UnderMenu fromUnknownPage={true} history={history} lang={lang} />
        </Router>
      </Provider>
    </React.StrictMode>,
    btnUnderMenu
  );

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router history={history}>
          <App store={store} history={history} lang={'ru'} />
        </Router>
      </Provider>
    </React.StrictMode>,
    authModule
  );

} else {
  const lang = 'ru';
  const btnUnderMenu = document.querySelector('.head_menu').querySelector('.l1').appendChild(document.createElement("div"));
  btnUnderMenu.setAttribute("id", "auth-under-menu");

  const authModule = document.body.insertBefore(document.createElement('div'), document.body.children[0]);
  authModule.setAttribute('id', 'auth-module');
  
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router history={history}>
          <UnderMenu history={history} lang={lang} />
        </Router>
      </Provider>
    </React.StrictMode>,
    btnUnderMenu
  );

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router history={history}>
          <App store={store} history={history} lang={lang} />
        </Router>
      </Provider>
    </React.StrictMode>,
    authModule
  );
}